import { useContext } from 'react';
import { SharedDocument } from 'types/Document';
import {Image} from 'components';
import { makeStyles } from '@mui/styles';
import { type Theme, Slide } from '@mui/material';
import { imageViewerContext } from './ImageViewerContext';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '90%',
    left: '15%',
    position: 'absolute',
    top: '5%',
    width: '70%',

    [theme.breakpoints.down('md')]: {
      height: '100%',
      left: 0,
      top: 0,
      width: '100%',
    },
  },
  hidden: {
    visibility: 'hidden',
  },
  image: {
    left: '50%',
    maxHeight: '100%',
    maxWidth: '100%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
}), { name: 'ImageViewerItem' });

type ImageViewerItemProps = {
  image: SharedDocument;
};

const ImageViewerItem = ({ image }: ImageViewerItemProps): JSX.Element => {
  
  const { currentViewedImage, slideDirection } = useContext(imageViewerContext);
  const hidden = currentViewedImage?.id !== image.id;

  const classes = useStyles();

  return (
    <Slide direction={slideDirection} in={!hidden} timeout={500}>
      <div className={classes.container}>
        <Image
          className={clsx([classes.image, hidden && classes.hidden])}
          src={image.blob.s3URL}
          aria-hidden={hidden}
        />
      </div>
    </Slide>
  );
};

export default ImageViewerItem;
